import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ContactInfo } from './contactInfo';
import { ProjectStatus } from '../../project-misc/data/project/statuses/project-status';

@JsonObject('model.customer.CustomerProj')
export class CustomerProj extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'number')
    number?: string;

    @JsonProperty(ProjectStatus, 'paymentStatus')
    paymentStatus?: ProjectStatus;

    @JsonProperty(String, 'status')
    status?: string;
}